"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxFilterRow = exports.FilterHeader = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectTypes_1 = require("Project/ProjectTypes");
var UserFilter_1 = __importDefault(require("Dashboard/FilterSelector/UserFilter/UserFilter"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var StringManipulater_1 = require("Utils/StringManipulater");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Types_2 = require("@CommonFrontendBackend/Analytics/Types");
var TemplatesSelector_1 = require("Common/Templates/TemplatesSelector");
var TagsSelector_1 = require("Common/PageFilters/TagsSelector");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("dashboard-filter");
var FilterSelector = (function (_super) {
    __extends(FilterSelector, _super);
    function FilterSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.clearAllFilters = function () {
            _this.projectListStore.clearSelectedFilters();
        };
        _this.handlePopoverChange = function (isOpen) {
            if (isOpen) {
                _this.areAnyFiltersSelectedOnOpen = _this.projectListStore.areAnyFiltersSelected;
            }
        };
        _this.projectListStore = props.projectListStore;
        _this.areAnyFiltersSelectedOnOpen = _this.projectListStore.areAnyFiltersSelected;
        return _this;
    }
    FilterSelector.prototype.render = function () {
        var _this = this;
        var _a = this.projectListStore, selectedTags = _a.selectedTags, setSelectedTags = _a.setSelectedTags, selectedTemplates = _a.selectedTemplates, setSelectedTemplates = _a.setSelectedTemplates;
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement(kaleidoscope_1.Popover, { onChange: this.handlePopoverChange, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
                    react_1.default.createElement(icons_1.Filter, null),
                    _this.filterLabel)); }, size: kaleidoscope_1.PopoverSize.Auto, maxHeight: "calc(100vh - 200px)" },
                react_1.default.createElement("div", { className: c("content") },
                    this.areAnyFiltersSelectedOnOpen && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, width: "full", onClick: this.clearAllFilters }, "Clear all filters")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(FilterSection, { heading: "Status" },
                            react_1.default.createElement("div", { className: c("checkboxes") },
                                react_1.default.createElement(exports.CheckboxFilterRow, { text: "Starred", checked: this.isStatusSelected(ProjectTypes_1.SpecialProjectTag.Starred), onChange: function () { return _this.toggleStatus(ProjectTypes_1.SpecialProjectTag.Starred); } }),
                                react_1.default.createElement(exports.CheckboxFilterRow, { text: "Draft", checked: this.isStatusSelected(Types_1.ProjectStatus.Draft), onChange: function () { return _this.toggleStatus(Types_1.ProjectStatus.Draft); } }),
                                react_1.default.createElement(exports.CheckboxFilterRow, { text: "Live", checked: this.isStatusSelected(Types_1.ProjectStatus.Live), onChange: function () { return _this.toggleStatus(Types_1.ProjectStatus.Live); } }),
                                react_1.default.createElement(exports.CheckboxFilterRow, { text: "Accepted", checked: this.isStatusSelected(Types_1.ProjectStatus.Accepted), onChange: function () { return _this.toggleStatus(Types_1.ProjectStatus.Accepted); } }),
                                react_1.default.createElement(exports.CheckboxFilterRow, { text: "Declined", checked: this.isStatusSelected(Types_1.ProjectStatus.Declined), onChange: function () { return _this.toggleStatus(Types_1.ProjectStatus.Declined); } }))),
                        react_1.default.createElement(FilterSection, { heading: "Page filters" },
                            react_1.default.createElement(TemplatesSelector_1.TemplatesSelector, { className: c("sub-section"), selectedTemplates: selectedTemplates, setSelectedTemplates: setSelectedTemplates }),
                            react_1.default.createElement(TagsSelector_1.TagsSelector, { className: c("sub-section"), selectedTags: selectedTags, setSelectedTags: setSelectedTags }),
                            react_1.default.createElement("div", { className: c("sub-section") },
                                react_1.default.createElement(kaleidoscope_1.Label, { size: "s", long: true }, "Has content"),
                                react_1.default.createElement("div", { className: c("off-center-checkboxes") }, pagesWithOrder.map(function (pagesWith) { return (react_1.default.createElement(exports.CheckboxFilterRow, { key: pagesWith, text: pagesWith, checked: _this.isPagesWithSelected(pagesWith), onChange: function () { return _this.togglePagesWith(pagesWith); } })); })))),
                        react_1.default.createElement(FilterSection, { heading: "Engagement" },
                            react_1.default.createElement("div", { className: c("off-center-checkboxes") }, engagementLevelsOrder.map(function (engagementLevel) { return (react_1.default.createElement(exports.CheckboxFilterRow, { key: engagementLevel, text: engagementLevel, checked: _this.isEngagementLevelSelected(engagementLevel), onChange: function () { return _this.toggleEngagementLevel(engagementLevel); } })); }))),
                        react_1.default.createElement(FilterSection, { heading: "People" },
                            react_1.default.createElement(UserFilter_1.default, { userList: this.projectListStore.userList, selectedUserIds: this.projectListStore.selectedUserIds, setSelectedUserIds: this.projectListStore.setSelectedUserIds, "$state": this.props.$state })))))));
    };
    Object.defineProperty(FilterSelector.prototype, "filterLabel", {
        get: function () {
            var _a = this.projectListStore, selectedUserIds = _a.selectedUserIds, selectedStatuses = _a.selectedStatuses, selectedTags = _a.selectedTags, selectedEngagementLevels = _a.selectedEngagementLevels, selectedPagesWithFilters = _a.selectedPagesWithFilters, selectedTemplates = _a.selectedTemplates;
            var numFilters = selectedUserIds.length +
                selectedStatuses.length +
                selectedTags.length +
                selectedEngagementLevels.length +
                selectedPagesWithFilters.length +
                selectedTemplates.length;
            if (numFilters > 9) {
                return "9+ filters";
            }
            else if (numFilters > 0) {
                return (0, StringManipulater_1.pluralise)(numFilters, "filter");
            }
            else {
                return "Filters";
            }
        },
        enumerable: false,
        configurable: true
    });
    FilterSelector.prototype.isStatusSelected = function (status) {
        var _this = this;
        return (0, mobx_1.computed)(function () {
            return _this.projectListStore.selectedStatuses.includes(status);
        }).get();
    };
    FilterSelector.prototype.toggleStatus = function (status) {
        var selected = this.projectListStore.selectedStatuses.includes(status);
        var newStatuses;
        if (selected) {
            newStatuses = this.projectListStore.selectedStatuses.filter(function (e) { return e !== status; });
        }
        else {
            newStatuses = this.projectListStore.selectedStatuses.concat(status);
        }
        this.projectListStore.setSelectedStatuses(newStatuses);
    };
    FilterSelector.prototype.isEngagementLevelSelected = function (engagementLevel) {
        return this.projectListStore.selectedEngagementLevels.includes(engagementLevel);
    };
    FilterSelector.prototype.toggleEngagementLevel = function (engagementLevel) {
        var newEngagementLevels;
        if (this.isEngagementLevelSelected(engagementLevel)) {
            newEngagementLevels = this.projectListStore.selectedEngagementLevels.filter(function (e) { return e !== engagementLevel; });
        }
        else {
            newEngagementLevels = this.projectListStore.selectedEngagementLevels.concat(engagementLevel);
        }
        this.projectListStore.setSelectedEngagementLevels(newEngagementLevels);
    };
    FilterSelector.prototype.isPagesWithSelected = function (pagesWith) {
        return this.projectListStore.selectedPagesWithFilters.includes(pagesWith);
    };
    FilterSelector.prototype.togglePagesWith = function (pagesWith) {
        var newPagesWith;
        if (this.isPagesWithSelected(pagesWith)) {
            newPagesWith = this.projectListStore.selectedPagesWithFilters.filter(function (e) { return e !== pagesWith; });
        }
        else {
            newPagesWith = this.projectListStore.selectedPagesWithFilters.concat(pagesWith);
        }
        this.projectListStore.setPagesWithFilters(newPagesWith);
    };
    var _a, _b, _c;
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_a = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _a : Object)
    ], FilterSelector.prototype, "usingFeature", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], FilterSelector.prototype, "areAnyFiltersSelectedOnOpen", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], FilterSelector.prototype, "filterLabel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], FilterSelector.prototype, "clearAllFilters", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], FilterSelector.prototype, "handlePopoverChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FilterSelector.prototype, "toggleStatus", null);
    FilterSelector = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], FilterSelector);
    return FilterSelector;
}(react_1.default.Component));
exports.default = FilterSelector;
var FilterSection = function (_a) {
    var heading = _a.heading, children = _a.children;
    return (react_1.default.createElement("div", { className: "".concat(c("section")) },
        react_1.default.createElement(exports.FilterHeader, { text: heading }),
        children));
};
var FilterHeader = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: c("header") },
        react_1.default.createElement("span", { className: "text-h4" }, text)));
};
exports.FilterHeader = FilterHeader;
var CheckboxFilterRow = function (_a) {
    var checked = _a.checked, text = _a.text, onChange = _a.onChange;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(kaleidoscope_2.Checkbox, { item: { id: text, value: text, label: text }, isSelected: checked, onChange: onChange })));
};
exports.CheckboxFilterRow = CheckboxFilterRow;
var engagementLevelsOrder = [
    "highly engaged",
    "engaged",
    "highly disengaged",
    "disengaged",
    "unmonitored",
    "neutral",
];
var pagesWithOrder = [
    Types_2.PagesWithFilter.AcceptBlock,
    Types_2.PagesWithFilter.Value,
    Types_2.PagesWithFilter.QuoteBlock,
];
